export interface AdminNotification{
    tab:string;
    sec:string;
    type:string;
    count:number;
}


export function getAdminNotificationCount(notificationList: AdminNotification[], opt:string, tab: string[]|null, sec: string[]|null){

    let count = 0;
    let tabList:string[]=[];
    let secList:string[]=[];
    
    for(let n of notificationList){

        if(opt=='tabCount' && !tabList.includes(n.tab)){
            count += 1;
            tabList.push(n.tab);
        }
        else if(opt=='secCount' && !secList.includes(n.sec)){
            count += 1;
            secList.push(n.sec);
        }
        else if( opt=='tabWise' && (!tab || tab.includes(n.tab)) ){
            count += 1;
        }
        else if( opt=='secWise' && (!sec || sec.includes(n.sec)) ){
            count += 1;
        }

    }

    return count;
    
}


export function removeAdminNotification(notificationList: AdminNotification[], tab:string[]|null, sec:string[]|null){

    let newList:AdminNotification[] = [];

    for(let n of notificationList){

        if(tab  && !tab.includes(n.tab)){
            newList.push(n);
        }
        else if(sec  && !sec.includes(n.sec)){
            newList.push(n);
        }

    }

    return newList;

}